import { IImageObject } from '@src/api/types'
import { ChartDataItem } from '@src/components/BarChartComponent/types'
import { capitalizeFirstLetter } from '@src/helpers/utils'

export const prepareBarChartData = (objects: IImageObject[]) => {
    const grouped = new Map<string, { volume_m3: number; area_px: number; mass_kg: number }>()

    for (const obj of objects) {
        const name = capitalizeFirstLetter(obj.class_name)
        if (!grouped.has(name)) {
            grouped.set(name, { volume_m3: 0, area_px: 0, mass_kg: 0 })
        }

        const current = grouped.get(name)!
        current.volume_m3 += obj.volume_m3
        current.area_px += obj.area_px
        current.mass_kg += obj.mass_kg
    }

    const volumeData: ChartDataItem[] = []
    const areaData: ChartDataItem[] = []
    const massData: ChartDataItem[] = []

    for (const [type, values] of grouped) {
        volumeData.push({ type, value: values.volume_m3 })
        areaData.push({ type, value: values.area_px })
        massData.push({ type, value: values.mass_kg })
    }

    return { volumeData, areaData, massData }
}

export const groupByType = (data: { type: string; value: number }[]) => {
    const map = new Map<string, number>()

    for (const item of data) {
        const current = map.get(item.type) ?? 0
        map.set(item.type, current + item.value)
    }

    return Array.from(map.entries()).map(([type, value]) => ({ type, value }))
}
